export default {
	VIDEO: 'video',
	IMAGE: 'image',
	BINARY: 'binary',
}
